import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Field } from "redux-form";
import { IonList } from "@ionic/react";
import styled from "styled-components";

import {
  FormInput,
  FormDatetimeInput,
  EditableDataDisplay,
  EditableImage,
} from "../../../common";
import { required } from "../../../common/validations";
import strings from "../../../../res/strings";

const EditableContainer = styled.div`
  margin: 16px;
`;
const EditableImageContainer = styled.div`
  margin: 16px;
  display: flex;
  align-items: flex-end;
`;
const ProfileTitle = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.05em;
  width: 100%;
  color: #000000;
`;

const EditableDataForm = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
`;

let AccountInformationDisplay = (props) => {
  useEffect(() => {
    props.initialize({
      first_name: props.accountInformation.first_name,
      middle_name: props.accountInformation.middle_name,
      last_name: props.accountInformation.last_name,
      birthdate: props.accountInformation.birthday,
      contact_mobile: props.accountInformation.contact_mobile,
      contact_landline: props.accountInformation.contact_landline,
      contact_email: props.accountInformation.contact_email,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={props.handleSubmit}>
      <IonList>
        <EditableImageContainer>
          <div style={{ alignSelf: "flex-start" }}>
            <EditableImage
              imageSource={props.accountInformation.avatar}
              imageAlternateString={`${props.accountInformation.first_name} ${props.accountInformation.last_name}`}
              selectedImages={props.selectedImages}
              setSelectedImages={props.setSelectedImages}
              maxFiles={1}
              onSubmit={props.onSubmit}
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </div>
        </EditableImageContainer>

        <EditableDataForm>
          <ProfileTitle>YOUR PROFILE</ProfileTitle>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_name_first}
              value={props.accountInformation.first_name}
              editComponent={
                <Field
                  name="first_name"
                  label={strings.lib_account_label_name_first}
                  type="text"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_name_middle}
              value={props.accountInformation.middle_name}
              editComponent={
                <Field
                  name="middle_name"
                  label={strings.lib_account_label_name_middle}
                  type="text"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_name_last}
              value={props.accountInformation.last_name}
              editComponent={
                <Field
                  name="last_name"
                  label={strings.lib_account_label_name_last}
                  type="text"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_birthdate}
              value={props.accountInformation.birthday}
              editComponent={
                <Field
                  name="birthdate"
                  label={strings.lib_account_label_birthdate}
                  required
                  component={FormDatetimeInput}
                  validate={[required]}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>

          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_contact_mobile}
              value={props.accountInformation.contact_mobile}
              editComponent={
                <Field
                  name="contact_mobile"
                  label={strings.lib_account_label_contact_mobile}
                  type="text"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={strings.lib_account_label_contact_landline}
              value={props.accountInformation.contact_landline}
              editComponent={
                <Field
                  name="contact_landline"
                  label={strings.lib_account_label_contact_landline}
                  type="text"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
          <EditableContainer>
            <EditableDataDisplay
              onSubmit={props.onSubmit}
              label={"Preferred Contact Email"}
              value={props.accountInformation.contact_email}
              editComponent={
                <Field
                  name="contact_email"
                  label={"Preferred Contact Email"}
                  type="email"
                  required
                  component={FormInput}
                  inputStyle={"plain"}
                />
              }
              openActiveFormEdit={props.openActiveFormEdit}
              closeActiveFormEdit={props.closeActiveFormEdit}
            />
          </EditableContainer>
        </EditableDataForm>
      </IonList>
    </form>
  );
};

AccountInformationDisplay = reduxForm({
  form: "lib_account_account_information_editable_display",
})(AccountInformationDisplay);

const mapStateToProps = (state) => ({
  accountInformationEditableDisplayForm:
    state.form.lib_account_account_information_editable_display,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

AccountInformationDisplay = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountInformationDisplay);

export default AccountInformationDisplay;
